import cn from "classnames";
import without from "lodash/without";
import React from "react";

const Legend = (props) => {
    const filterByKind = (kind) => {
        if (props.disableFilters) {
            return;
        }

        const kindVal = props.kindFilter?.includes(kind)
            ? without(props.kindFilter, kind)
            : [...(props.kindFilter ?? []), kind];
        props.setValue({ name: "kindFilter", value: kindVal });
    };

    const legendCname = (mainClass, kind) =>
        cn(mainClass, {
            "carnumber__wrap--disabled":
                !props.disableFilters && props.kindFilter?.length > 0 && !props.kindFilter.includes(kind),
            "carnumber__wrap--noclickable": props.disableFilters,
        });
    const filterClickHandler = (kind) => (props.disableFilters ? undefined : () => filterByKind(kind));
    const { counters } = props;
    return (
        <div className="py-1 p-legend">
            <div className={legendCname("carnumber__wrap--green", "hasPlannedBid")}>
                <div
                    className="carnumber__number carnumber__number--without-region py-1"
                    onClick={filterClickHandler("hasPlannedBid")}
                >
                    Запланирована заявка по приезду&nbsp;
                    <span className="badge badge-info">{counters.hasPlannedBid}</span>
                </div>
            </div>
            <div className={legendCname("carnumber__wrap--yellow", "withBid")}>
                <div
                    className="carnumber__number carnumber__number--without-region py-1"
                    onClick={filterClickHandler("withBid")}
                >
                    Не запланирована заявка по приезду&nbsp;
                    <span className="badge badge-info">{counters.withBid}</span>
                </div>
            </div>
            <div className={legendCname("carnumber__wrap--blue", "isLastBidPointVisited")}>
                <div
                    className="carnumber__number carnumber__number--without-region py-1"
                    onClick={filterClickHandler("isLastBidPointVisited")}
                >
                    На выгрузке&nbsp;
                    <span className="badge badge-info">{counters.isLastBidPointVisited}</span>
                </div>
            </div>
            <div className={legendCname("carnumber__wrap--red", "withoutBidPeriod")}>
                <div
                    className="carnumber__number carnumber__number--without-region py-1"
                    onClick={filterClickHandler("withoutBidPeriod")}
                >
                    Простаивает без заявки&nbsp;
                    <span className="badge badge-info">{counters.withoutBidPeriod}</span>
                </div>
            </div>
            <div className={legendCname("carnumber__wrap--lightgray", "withBookingComment")}>
                <div
                    className="carnumber__number carnumber__number--without-region py-1"
                    onClick={filterClickHandler("withBookingComment")}
                >
                    Забронировано&nbsp;
                    <span className="badge badge-info">{counters.withBookingComment}</span>
                </div>
            </div>
        </div>
    );
};

export default Legend;
